import * as actions from './actions';
import * as selectors from './selectors';

import reducers from './reducers';

const price = { actions, reducers, selectors };
export default price;
